import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EventPoster from "./EventPoster";
import Leaderboard from "./Leaderboard";
import RegistrationForm from "./RegistrationForm";
import AdditionalInfo from "./AdditionalInformation";

import April25Page from "./April25";
import May25Page from "./May25";
import June25Page from "./June25";
import July25Page from "./July25";
import August25Page from "./August25";
import September25Page from "./September25";
import October25Page from "./October25";
import NovDec25Page from "./NovDec25";
import January26Page from "./January26";
import February26Page from "./February26";


import SimpleTableDistance from "./SimpleTableDistance";
//import SimpleTableStrength from "./SimpleTableStrength"; //Max Count Metirc, Pushups, Squats, etc.
import SimpleTableStrengthPoints from "./SimpleTableStrengthPoints";
//import SimpleTableDspStrength from "./SimpleTableDspStrength";
import SimpleTableWallsit from "./SimpleTableWallsit";
//import SimpleTablePlank from "./SimpleTablePlank";
import SimpleTableTeams from "./SimpleTableTeams";
import TeamDistribution from "./TeamDistribution";
import RulesAndRegulations from "./RulesAndRegulations";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<EventPoster />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/register" element={<RegistrationForm />} />
      <Route path="/info" element={<AdditionalInfo />} />
      <Route path="/april25" element={<April25Page />} />
      <Route path="/may25" element={<May25Page />} />
      <Route path="/june25" element={<June25Page />} />
      <Route path="/july25" element={<July25Page />} />
      <Route path="/august25" element={<August25Page />} />
      <Route path="/september25" element={<September25Page />} />
      <Route path="/october25" element={<October25Page />} />
      <Route path="/novdec25" element={<NovDec25Page />} />
      <Route path="/january26" element={<January26Page />} />
      <Route path="/february26" element={<February26Page />} />
      <Route path="/team-distribution" element={<TeamDistribution />} />
      <Route path="/rules_and_regulations" element={<RulesAndRegulations />} />
    </Routes>
  </Router>
);

